import { render, staticRenderFns } from "./SigTransfer.vue?vue&type=template&id=3b44301c&scoped=true&"
import script from "./SigTransfer.vue?vue&type=script&lang=js&"
export * from "./SigTransfer.vue?vue&type=script&lang=js&"
import style0 from "./SigTransfer.vue?vue&type=style&index=0&id=3b44301c&scoped=true&lang=less&"
import style1 from "./SigTransfer.vue?vue&type=style&index=1&id=3b44301c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b44301c",
  null
  
)

export default component.exports